import  { useState } from "react";
import { useTranslation } from 'react-i18next';
import { BiSlider } from "react-icons/bi";
import { BiCog } from "react-icons/bi";
import { BiPalette } from "react-icons/bi";
import { FaPlus } from "react-icons/fa";
import { MdOutlineFactCheck } from "react-icons/md";
import { TbMessage2Question } from "react-icons/tb";
import { MdQueryStats } from "react-icons/md";
import Flashcard from './flashcard';
import Image from "../assets/webp/SectionReflect.webp"

// Mapeo de iconos para mantener el orden con las features traducidas
const icons = [
  <BiCog alt="icono" className="animate-pulse" />,
  <BiPalette alt="icono" className="animate-pulse" />,
  <BiSlider alt="icono" className="animate-pulse" />,
  <MdOutlineFactCheck alt="icono" className="animate-pulse" />,
  <TbMessage2Question alt="icono" className="animate-pulse" />,
  <MdQueryStats alt="icono" className="animate-pulse" />,
];

const Features = () => {
  const { t } = useTranslation();

  // Obtiene las features traducidas
  const features = t('features.cards', { returnObjects: true });
  // Asegura que cada feature tenga el icono y el flag de botón si corresponde
  const featuresWithIcons = features.map((feature, idx) => ({
    ...feature,
    id: idx + 1,
    icon: icons[idx],
    button: idx >= 2 // Solo las últimas 4 tienen botón
  }));

  const [selectedFeature, setSelectedFeature] = useState(null);

  const handleOpenOverlay = (featureId) => {
    const featureToShow = featuresWithIcons.find((f) => f.id === featureId);
    setSelectedFeature(featureToShow || null);
  };

  const handleCloseOverlay = () => {
    setSelectedFeature(null);
  };

  return (
    <section className="text-center" id="features">
      <div className="ft-section space-y-5 md:space-x-20">
        {/* Sección del título e imagen */}
        <div className="flex flex-col items-center space-y-5 mt-4 ft-image">
          <img
            src={Image}
            alt="Gráfico"
            className="min-w-full h-auto animate-zoom2"
          />
          <div className="w-full space-y-1">
            <h1 className="space-y-0 font-sans text-secondary font-bold resp-h3">
              {t('features.title').split('\\n').map((line, idx) => (
                <span key={idx}>
                  {line}
                  {idx !== t('features.title').split('\\n').length - 1 && <br />}
                </span>
              ))}
            </h1>
            <p className="hero-p resp-body5" style={{ lineHeight: "130%" }}>
              {t('features.subtitle')}
            </p>
            <button className="font-archivo resp-body5 btn-secondary mb-4 mt-4"
              style={{ marginTop: "5%" }}
              onClick={() => window.open("https://wa.toolia.site/cursos2tor", "_blank")}
            >
              {t('features.demo_btn')}
            </button>
          </div>
        </div>

        {/* Sección de tarjetas */}
        <div className="ft-list">
          <div className="ft-grid">
            {featuresWithIcons.map((feature) => (
              <div key={feature.id} className="tags">
                <div className="icon-pink animate-fade-in mb-4">
                  {feature.icon}
                </div>
                <h3
                  className="font-archivo ft-title"
                  style={{ lineHeight: "120%" }}
                >
                  {feature.title}
                </h3>
                <p className="text-[14px] text-secondary text-sans ft-p break-words mb-4">{feature.description}</p>
                {feature.button && (
                  <div className="mt-4">
                    <button
                      className="text-[14px] ft-p font-sans btn-secondary"
                      style={{
                        display: "flex",
                        backgroundColor: "transparent",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        padding: "2.5% 8%",
                        gap: "5px",
                      }}
                      onClick={() => handleOpenOverlay(feature.id)}
                    >
                      <FaPlus style={{ fontSize: "clamp(1.2vw,12px,16vw)" }} />
                      {t('features.read_more')}
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Overlay Flashcard */}
      <Flashcard
        selectedFeatureId={selectedFeature?.id}
        onClose={handleCloseOverlay}
      />
    </section>
  );
};

export default Features;